export default class TypeResidency {
  id!: number
  residency_type!: string
  isEdit!: boolean
}
